import { ActiveTabType } from 'data/types';
import { ductedDesignIncompleteReason } from 'utils/ducted-design-copy';
import { DuctedPairLinkMode } from 'utils/ducted-design-types';
import { getBypassTabLocks, TabLocks } from 'utils/system-design-bypass';
import { GetTabLocksParams } from 'utils/tab-locks-types';

const DUCTED_DESIGN_LOCK_ESCAPE: ActiveTabType = 'configurations';

const DUCTED_DESIGN_PENDING_TAB_LOCKS: Record<DuctedPairLinkMode, TabLocks> = {
  manual: {
    chooseSystems: {
      message: ductedDesignIncompleteReason('manual'),
      escapeTo: DUCTED_DESIGN_LOCK_ESCAPE
    }
  },
  automatic: {
    chooseSystems: {
      message: ductedDesignIncompleteReason('automatic'),
      escapeTo: DUCTED_DESIGN_LOCK_ESCAPE
    }
  }
};

export function getTabLocks({
  bypassMode,
  ductedDesignPending,
  ductedPairLinkMode
}: GetTabLocksParams): TabLocks {
  if (ductedDesignPending) {
    return DUCTED_DESIGN_PENDING_TAB_LOCKS[ductedPairLinkMode];
  }
  return getBypassTabLocks(bypassMode);
}
